import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import BlockyMediumText from "components/custom-texts/blocky-medium-text";
import Header from "components/header";
import Headroom from "react-headroom";
import { Link } from "react-router-dom";
import styles from "./styles.module.css";
import ExclusionsAndLimitationsForms from "./exclusions-and-limitations-forms";

const ResponsibleGamingContainer = () => {
  return (
    <>
      <Headroom>
        <Header />
      </Headroom>
      <div className={styles.pageWrapper}>
        <div className="mb-4">
          <Link 
            to="/profile"
            className="text-gray-600 hover:text-gray-800 flex items-center gap-2"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="20" 
              height="20" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
            >
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            Back to Profile
          </Link>
        </div>
        <BlockyHeavyText className={styles.title}>
          Responsible Gaming
        </BlockyHeavyText>
        <BlockyMediumText>
          Please enjoy our games responsibly and sensibly. If you or someone you know has a gambling or gaming problem and wants help, call 1-800-GAMBLER. You can learn more about responsible play via the{" "}
          <a href="https://www.americangaming.org/responsibility/responsible-play/" target="_blank" rel="noopener noreferrer">
            American Gaming Association
          </a>. Our games are meant for players 18 and older ONLY (in some jurisdictions, this age limit may be higher and you will be notified when signing up). We employ ID verification methods to ensure everyone playing is of age. Never allow a minor to use your account.
        </BlockyMediumText>
        <BlockyMediumText>
          This page allows you to set limits or exclude yourself from real money gaming (by setting a deposit limit of $0) for a period of time. Limit increases will be reviewed and may have a cooling off period of 24 hours. If you already have an exclusion in place, you will need to contact us to remove or modify it.
        </BlockyMediumText>
        <ExclusionsAndLimitationsForms />
      </div>
    </>
  );
};

export default ResponsibleGamingContainer;
